/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AnalyticsService from 'cio/services/analytics';
import SidebarService, { StaticSidebarId } from 'cio/services/sidebar';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import ApiService from 'cio/services/api';
import AIService from 'cio/services/ai';
import CampaignModel from 'cio/models/campaign';
import TemplateModel from 'cio/models/template';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    campaign?: CampaignModel;
    template: TemplateModel;
  };
}

export default class GenerateLiquidWithAi extends Component<Signature> {
  @service analytics!: AnalyticsService;
  @service sidebar!: SidebarService;
  @service api!: ApiService;
  @service ai!: AIService;

  readonly sidebarId = StaticSidebarId.GenerateLiquidWithAi;

  readonly isLiquidAiEnabled = this.ai.isAiFeatureEnabledForUser('show_objects_liquid_via_ai');

  readonly isAvailable =
    this.isLiquidAiEnabled &&
    this.args.campaign != null &&
    (this.args.campaign.isObjectTriggered || this.args.campaign.isObjectRelationshipTriggered);

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);

    this.sidebar.sidebarPanelClass[this.sidebarId] = 'max-w-[440px]';
  }

  @action
  openSidebar() {
    this.sidebar.open(this.sidebarId);
  }
}
